import { SubHeading } from '@/legacy/components/Typography'

import type { CountdownStyleProps, CountdownTextColor, RemainingTime } from '../types'

import Counter from './Counter'
import { CountdownContainer, CountdownItem } from './styles'

interface Props extends Omit<CountdownStyleProps, 'labelColorModifier' | 'clockColorModifier'> {
  remainingTime: RemainingTime
  labelColor?: CountdownTextColor
  clockColor?: CountdownTextColor
  className?: string
}
const DaysCountdown = ({ remainingTime, labelColor, className, ...clockStyles }: Props) => {
  const splitDays = remainingTime.days.split('')
  return (
    <CountdownContainer className={className}>
      <SubHeading {...labelColor} emphasys>
        Faltam
      </SubHeading>
      <CountdownItem>
        <Counter digits={splitDays} {...clockStyles} />
      </CountdownItem>
      <SubHeading {...labelColor} emphasys>
        dias para terminar
      </SubHeading>
    </CountdownContainer>
  )
}

export default DaysCountdown
